import React from "react";

// Mui
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import IconButton from "@mui/material/IconButton";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import "../styles/components/zoomFullScreen.css";
// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Config
import connectConfig from "../config/connectConfig";

const TransferInvoiceDataRow = (props) => {
  const { data, handleChecked } = props;

  // States
  const [open, setOpen] = React.useState(true);
  const [isZoomFullScreenOpen, setZoomFullScreenOpen] = React.useState(false);
  const [photoSource, setPhotoSource] = React.useState("");

  //turn on ZoomFullScreen and store uri soure into state
  const handleClickOpen = (src) => {
    setPhotoSource(src);
    setZoomFullScreenOpen(true);
  };

  // turn off ZoomFullScreen
  const handleClose = () => {
    setZoomFullScreenOpen(false);
  };

  return (
    <TableBody>
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.alias}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {`${data.from_staff_code} - ${data.from_alias}`}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          <ArrowForwardIcon></ArrowForwardIcon>
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {`${data.to_staff_code} - ${data.to_alias}`}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.reason}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.remark}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {moment(data.time_created).format("YYYY-MM-DD HH:mm:ss")}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {!open ? (
              <ArrowDropDownIcon fontSize="inherit" />
            ) : (
              <ArrowDropUpIcon fontSize="inherit" />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      {open && (
        <>
          {data.item.length > 0 &&
            data.item.map((item, itemIndex) => (
              <DataCell
                key={itemIndex}
                item={item}
                open={open}
                itemNo={itemIndex + 1}
              />
            ))}
        </>
      )}
      <TableRow>
        <TableCell
          colSpan={11}
          sx={{
            // backgroundColor: open ? "#f4f6f8" : "white",
            backgroundColor: "white",
          }}
        >
          {Object.values(data.attachments).length > 0 && (
            <ImageList cols={9}>
              {Object.values(data.attachments).map((item, i) => (
                <ImageListItem key={i}>
                  <div
                    onClick={() =>
                      handleClickOpen(`${connectConfig.s3}/${item}`)
                    }
                    className="zoom-in"
                    role="img"
                    style={{
                      borderRadius: "14px",
                      width: "100%",
                      minWidth: "150px",
                      minHeight: "150px",
                      border: "1px solid #f4f6f8",
                      backgroundImage: `url("${connectConfig.s3}/${item}")`,
                      backgroundPosition: "50%",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </TableCell>
      </TableRow>
    </TableBody>
  );

  function DataCell(props) {
    const { open, item, itemNo } = props;

    return (
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {itemNo}.
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {item.item}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {Math.abs(item.transfer_qty) * 1}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>

        <TableCell
          align=""
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {/* <Button
              variant={item.is_checked ? "contained" : "outlined"}
              color={item.is_checked ? "success" : "info"}
              size="small"
              onClick={() => handleChecked(data)}
            >
              {item.is_checked === false ? "未檢查" : "已檢查"}
            </Button> */}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
      </TableRow>
    );
  }
};

export default TransferInvoiceDataRow;
